import React, { useEffect, useState } from 'react'
import { ColoriFormatiPageConfig } from '../configuration'
import { useMediaQuery } from '@material-ui/core'
import AssignId from '../AssignId'
import Container from '../Container'
import styles from './ColoriFormati.module.sass'
import formato60x120 from './assets/images/formato60x120.svg'
import formato120x120 from './assets/images/formato120x120.svg'
import formatoBrick from './assets/images/formatoBrick.svg'
import luceImage from './assets/images/luce.jpg'
import fumoImage from './assets/images/fumo.jpg'
import incensoImage from './assets/images/incenso.jpg'
import luceImageMobile from './assets/images/luce_mobile.jpg'
import fumoImageMobile from './assets/images/fumo_mobile.jpg'
import incensoImageMobile from './assets/images/incenso_mobile.jpg'
import { Plus, Minus, Close } from '../icons'
import VisibilitySensor from '../VisibilitySensor'


function ColoriFormati() {
  const isMobile = useMediaQuery('(max-width: 760px)')
 
  const elements = [
    { key: 'luce', title: 'Luce', description: ColoriFormatiPageConfig.item1, image: luceImage, imageMobile: luceImageMobile, formati: [
      { key: 'luce_60x120', image: formato60x120, title: '60x120', description: '24"x48" R<br><br><span style="color:#7A1C30;">Cerasilk<br>Matt-Pro</span>' },
      { key: 'luce_120x120', image: formato120x120, title: '120x120', description: '48"x48" R<br><br><span style="color:#7A1C30;">Cerasilk<br>Matt-Pro</span>' },
      { key: 'luce_brick', image: formatoBrick, title: '6x24', description: '2<sup>3/8"</sup> x 9<sup>7/16"</sup><br><br>&nbsp;<br>&nbsp;' },
    ] },
    { key: 'incenso', title: 'Incenso', description: ColoriFormatiPageConfig.item2, image: incensoImage, imageMobile: incensoImageMobile, formati: [
      { key: 'incenso_60x120', image: formato60x120, title: '60x120', description: '24"x48" R<br><br><span style="color:#7A1C30;">Cerasilk<br>Matt-Pro</span>' },
      { key: 'incenso_120x120', image: formato120x120, title: '120x120', description: '48"x48" R<br><br><span style="color:#7A1C30;">Cerasilk<br>Matt-Pro</span>' },
      { key: 'incenso_brick', image: formatoBrick, title: '6x24', description: '2<sup>3/8"</sup> x 9<sup>7/16"</sup><br><br>&nbsp;<br>&nbsp;' },
    ]  },
    { key: 'fumo', title: 'Fumo', description: ColoriFormatiPageConfig.item3, image: fumoImage, imageMobile: fumoImageMobile, formati: [
      { key: 'fumo_60x120', image: formato60x120, title: '60x120', description: '24"x48" R<br><br><span style="color:#7A1C30;">Cerasilk<br>Matt-Pro</span>' },
      { key: 'fumo_120x120', image: formato120x120, title: '120x120', description: '48"x48" R<br><br><span style="color:#7A1C30;">Cerasilk<br>Matt-Pro</span>' },
      { key: 'fumo_brick', image: formatoBrick, title: '6x24', description: '2<sup>3/8"</sup> x 9<sup>7/16"</sup><br><br>&nbsp;<br>&nbsp;' },
    ]  },
  ]

  const [hoveredElement, setHoveredElement] = useState(null)
  const [lastHoveredElement, setLastHoveredElement] = useState(null)
  const [openElement, setOpenElement] = useState(null)
  const [openElementMobile, setOpenElementMobile] = useState(null)
  const [animationGo, setAnimationGo] = useState(false)
  const [animationBack, setAnimationBack] = useState(false)

  useEffect(() => {
    // Gestisce l'animazione quando cambia l'open element nella versione desktop
    if (hoveredElement){
      setLastHoveredElement(hoveredElement)
      setAnimationGo(true)
      setTimeout(() => {
        setAnimationGo(false)
      }, 300)
    }
    else {
      setAnimationBack(true)
      setTimeout(() => {
        setAnimationBack(false)
        setLastHoveredElement(null)
      }, 300)
    }
  }, [hoveredElement])


  return (
    <>
      <div className={styles.root}>
        <Container>
          <div className={styles.main}>
            <AssignId
              absolute
              y='-120px'
              yMobile='-80px'
              id={ColoriFormatiPageConfig.id}
            />
            <VisibilitySensor index={5} />
            <div className={`${styles.content} scroll-fadein`}>
              <p className={styles.intro}>{ColoriFormatiPageConfig.intro}</p>
              <h1 className={styles.title}>{ColoriFormatiPageConfig.title}</h1>
			  <div className={styles.description} dangerouslySetInnerHTML={{ __html: ColoriFormatiPageConfig.description }} />
            </div>
            <div className={`${styles.list} scroll-fadein-late`}>
              {elements.map(x => (
                <div 
                  key={x.key}
                  className={`${styles.item} ${animationGo ? styles['item--animationGo'] : ''} ${animationBack ? styles['item--animationBack'] : ''} ${openElement?.key === x.key ? styles['item--open'] : ""} ${hoveredElement ? hoveredElement.key === x.key ? styles['item--hovered'] : styles['item--noHovered'] : '' } ${lastHoveredElement ? lastHoveredElement.key === x.key ? styles['item--lastHovered'] : styles['item--noLastHovered'] : '' }`} 
                  onClick={() => { setOpenElement(openElement?.key === x.key ? null : x); setOpenElementMobile(openElement?.key === x.key ? null : x) }}
                >
                  <div className={styles.itemImageBox} onMouseEnter={() => { setHoveredElement(x); setOpenElement(null) }} onMouseLeave={() => { setHoveredElement(null); setOpenElement(null) }}>
                    <img src={(isMobile) ? x.imageMobile : x.image} className={styles.itemImage} alt={x.title} />
                    <div className={styles.formati}>
                      <p className={styles.formatiTitle}>{ColoriFormatiPageConfig.disponibile}</p>
                      <div className={styles.formatiList}>
                        {x.formati.map(f => (
                          <div className={styles.formatiItem} key={f.key}>
                            <div className={styles.formatiItemImageBox}>
                              <img src={f.image} alt={`${x.title} - ${f.title}`} />
                            </div>
                            <p className={styles.formatiItemTitle}>{f.title}</p>
		                    <div className={styles.formatiItemDescription} dangerouslySetInnerHTML={{__html: f.description}}></div>
                          </div>
                        ))}
                      </div>
                      <div className={styles.formatiMinus}><Minus /></div>
                    </div>
                    <div className={styles.itemButton}>
                      <span className={styles.itemButtonLabel}>{ColoriFormatiPageConfig.scopri}</span>
                      <Plus />
                    </div>
                  </div>
                  <div className={styles.itemContent}>
                    <p className={styles.itemTitle}>{x.title}</p>
                    <div className={styles.itemDescription}>{x.description}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </Container>
      </div>
      <div className={`${styles.formatiModalOverlay} ${openElementMobile ? styles['formatiModalOverlay--visible'] : ''}`} onClick={() => setOpenElementMobile(null)} />
      <div className={`${styles.formatiModal} ${openElementMobile ? styles['formatiModal--visible'] : ''}`}>
        <button className={styles.formatiModalClose} onClick={() => setOpenElementMobile(null)}>
          <Close />
        </button>
        {!!openElementMobile && (
          <>
            <p className={styles.formatiModalTitle}>{openElementMobile.title}</p>
            <p className={styles.formatiModalDescription}>{openElementMobile.description}</p>
            <div className={styles.formatiModalList}>
              {openElementMobile.formati.map(f => (
                <div className={styles.formatiItem} key={f.key}>
                  <div className={styles.formatiItemImageBox}>
                    <img src={f.image} alt={`${openElementMobile.title} - ${f.title}`} />
                  </div>
                  <p className={styles.formatiItemTitle}>{f.title}</p>
                  <p className={styles.formatiItemDescription}>{f.description}</p>
                </div>
              ))}
            </div>
          </>
        )}
      </div>
    </>
  )
}

export default ColoriFormati
